export { default, getServerSideProps } from './_error';
